import { useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import CollapsibleCard from "../CollapsibleCard";
import stringToReactNodesWithLinks from "./stringToReactNodesWithLinks";

interface NotesProps {
  notes: string;
  siteLocked: boolean;
  setSite: (update) => void;
}

const Notes = ({ notes, siteLocked, setSite }: NotesProps) => {
  const [renderEnabled, setRenderEnabled] = useState(siteLocked);
  return (
    <CollapsibleCard
      title={"Notes"}
      className="mt-2"
      menu={
        <Form.Group controlId="debugCheck">
          <Form.Check
            type="switch"
            label="Render"
            checked={renderEnabled}
            onChange={(e) => setRenderEnabled(e.target.checked)}
          />
        </Form.Group>
      }
    >
      <Row>
        <Col>
          {renderEnabled && (
            <div
              style={{
                whiteSpace: "pre-wrap",
                overflowWrap: "anywhere",
                wordBreak: "normal",
              }}
            >
              {stringToReactNodesWithLinks(notes)}
            </div>
          )}
          {!renderEnabled && (
            <Form.Group className="mb-3" controlId="notes">
              <Form.Control
                as="textarea"
                rows={30}
                value={notes}
                onChange={(e) => setSite({ notes: e.target.value })}
                data-testid="site-notes"
              />
            </Form.Group>
          )}
        </Col>
      </Row>
    </CollapsibleCard>
  );
};

export default Notes;
